import api from '.';

export function listar({ start = 0, size = 10, filters = '[]', filtersMode = '{}', globalFilter = '', sorting = '[]' } = {}) {
    return api.get('/unidadeCondominialProduto/listar', {
        params: {
            start,
            size,
            filters,
            filtersMode,
            globalFilter,
            sorting,
        },
    });
}
export function listarServicosDisponiveis({ empresaId, tabelaPrecoId, filtro = '', data = null, limite = 50 } = {}) {
    return api.get('/unidadeCondominialProduto/servicosDisponiveis', {
        params: {
            empresaId,
            tabelaPrecoId,
            filtro,
            data,
            limite,
        },
    });
}
export function listarTabelasDisponiveis({ empresaId, filtro = '', limite = 50 } = {}) {
    return api.get('/unidadeCondominialProduto/tabelasDisponiveis', {
        params: {
            empresaId,
            filtro,
            limite,
        },
    });
}
export function consultar(uuid) {
    return api.get(`/unidadeCondominialProduto/editar/${uuid}`);
}

export function cadastrar(dados) {
    return api.post('/unidadeCondominialProduto/cadastrar', dados);
}

export function editar(uuid, dados) {
    return api.post('/unidadeCondominialProduto/editar', {
        ...dados,
        uuid,
    });
}

export function excluir(uuid) {
    return api.post('/unidadeCondominialProduto/deletar', {
        id: uuid,
    });
}

export function relatorio({
    filters = '[]',
    filtersMode = '{}',
    globalFilter = '',
    sorting = '[]',
    somenteDuplicidades = false,
} = {}) {
    return api.get('/unidadeCondominialProduto/relatorio', {
        params: { filters, filtersMode, globalFilter, sorting, somenteDuplicidades },
        responseType: 'blob',
    });
}
